// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/activity/activity_dietary_preference.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/activity/activity_dietary_preference.proto.
 */
export const file_proto_model_booking_activity_activity_dietary_preference = /*@__PURE__*/
  fileDesc("Cj5wcm90by9tb2RlbC9ib29raW5nL2FjdGl2aXR5L2FjdGl2aXR5X2RpZXRhcnlfcHJlZmVyZW5jZS5wcm90bxIGY2FybWVuIrMBChlBY3Rpdml0eURpZXRhcnlQcmVmZXJlbmNlEjEKDGRpZXRhcnlfdHlwZRgBIAEoDjIbLmNhcm1lbi5BY3Rpdml0eURpZXRhcnlUeXBlEhMKC2Rlc2NyaXB0aW9uGAIgASgJEjEKCHNldmVyaXR5GAMgASgOMh8uY2FybWVuLkFjdGl2aXR5RGlldGFyeVNldmVyaXR5EhsKE2FsdGVybmF0aXZlX29wdGlvbnMYBCADKAkq5AMKE0FjdGl2aXR5RGlldGFyeVR5cGUSJQohQUNUSVZJVFlfRElFVEFSWV9UWVBFX1VOU1BFQ0lGSUVEEAASJAogQUNUSVZJVFlfRElFVEFSWV9UWVBFX1ZFR0VUQVJJQU4QARIfChtBQ1RJVklUWV9ESUVUQVJZX1RZUEVfVkVHQU4QAhIlCiFBQ1RJVklUWV9ESUVUQVJZX1RZUEVfR0xVVEVOX0ZSRUUQAxIfChtBQ1RJVklUWV9ESUVUQVJZX1RZUEVfSEFMQUwQBBIgChxBQ1RJVklUWV9ESUVUQVJZX1RZUEVfS09TSEVSEAUSJQohQUNUSVZJVFlfRElFVEFSWV9UWVBFX05VVF9BTExFUkdZEAYSKwonQUNUSVZJVFlfRElFVEFSWV9UWVBFX1NIRUxMRklTSF9BTExFUkdZEAcSJAogQUNUSVZJVFlfRElFVEFSWV9UWVBFX0RBSVJZX0ZSRUUQCBIkCiBBQ1RJVklUWV9ESUVUQVJZX1RZUEVfTE9XX1NPRElVTRAJEiIKHkFDVElWSVRZX0RJRVRBUllfVFlQRV9ESUFCRVRJQxAKEjEKLUFDVElWSVRZX0RJRVRBUllfVFlQRV9OT19TUEVDSUFMX1JFUVVJUkVNRU5UUxALKvABChdBY3Rpdml0eURpZXRhcnlTZXZlcml0eRIpCiVBQ1RJVklUWV9ESUVUQVJZX1NFVkVSSVRZX1VOU1BFQ0lGSUVEEAASKAokQUNUSVZJVFlfRElFVEFSWV9TRVZFUklUWV9QUkVGRVJFTkNFEAESKQolQUNUSVZJVFlfRElFVEFSWV9TRVZFUklUWV9SRVNUUklDVElPThACEiUKIUFDVElWSVRZX0RJRVRBUllfU0VWRVJJVFlfQUxMRVJHWRADEi4KKkFDVElWSVRZX0RJRVRBUllfU0VWRVJJVFlfTElGRV9USFJFQVRFTklORxAEQjBaLmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2Jvb2tpbmdiBnByb3RvMw");

/**
 * Describes the message carmen.ActivityDietaryPreference.
 * Use `create(ActivityDietaryPreferenceSchema)` to create a new message.
 */
export const ActivityDietaryPreferenceSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_activity_dietary_preference, 0);

/**
 * Describes the enum carmen.ActivityDietaryType.
 */
export const ActivityDietaryTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_activity_dietary_preference, 0);

/**
 * @generated from enum carmen.ActivityDietaryType
 */
export const ActivityDietaryType = /*@__PURE__*/
  tsEnum(ActivityDietaryTypeSchema);

/**
 * Describes the enum carmen.ActivityDietarySeverity.
 */
export const ActivityDietarySeveritySchema = /*@__PURE__*/
  enumDesc(file_proto_model_booking_activity_activity_dietary_preference, 1);

/**
 * @generated from enum carmen.ActivityDietarySeverity
 */
export const ActivityDietarySeverity = /*@__PURE__*/
  tsEnum(ActivityDietarySeveritySchema);

